import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
// import Nutshell from '@/components/homepage/nutshell'
import Casestudies from '@/components/homepage/casestudies'
import Work from '@/components/work'
import Flock from '@/components/theflock'
import Profile from '@/components/profile'
import Project from '@/components/Project'
import Services from '@/components/ourservices'
import Service from '@/components/service'
import Packages from '@/components/packages'
import Policy from '@/components/policy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {key: 0}
    },
    {
      path: '/casestudies',
      name: 'casestudies',
      component: Casestudies,
      meta: {key: 1}
    },
    {
      path: '/services',
      name: 'ourservices',
      component: Services,
      meta: {key: 3}
    },
    {
      path: '/kia-kaha-nz',
      name: 'packages',
      component: Packages,
      meta: {key: 4}
    },
    {
      path: '/privacy-policy',
      name: 'policy',
      component: Policy,
      meta: {key: 5}
    },
    {
      path: '/services/:slug',
      name: 'Service',
      component: Service,
      meta: {key: ':/id'}
    },
    {
      path: '/theflock',
      name: 'theFlock',
      component: Flock,
      meta: {key: 2}
    },
    {
      path: '/theflock/:slug',
      name: 'Profile',
      component: Profile,
      meta: {key: ':/id'}
    },
    {
      path: '/ourwork/:slug',
      name: 'Project',
      component: Project,
      meta: {key: ':/id'}
    },
    {
      path: '/ourwork/:slug',
      name: 'Work',
      component: Work,
      meta: {key: ':/id'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js